export const PROFILE_LOAD = '@profile/load';
export const PROFILE_LOAD_FRIENDS = '@profile/load-friends';
export const PROFILE_LOAD_LOCATION = '@profile/load-location';
export const PROFILE_LOAD_PHONE = '@profile/load-phone';
